module.exports = __webpack_public_path__ + "static/media/beatrice.4ba9bdd9.png";